/**
* @ngdoc service
* @name common.service:NavigationService
* @description
* This service will centralize redirections.
* 
* @example
* Store Param object
* <pre>
* {
*  storeId: 34009450,
*  langId: -1,
*  catalogId: 30029002,
* }
* </pre>
*
* </pre>
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('NavigationService', NavigationService);

    NavigationService.$inject = ['CmsConfigSvc'];

    function NavigationService(CmsConfigSvc) {
        
        var service =  {
            goToAuthPage: goToAuthPage,
            getHelpURL: getHelpURL,
            goToCheckoutPage: goToCheckoutPage,
            goToHomePage: goToHomePage,
            goToAngularCheckoutPage:goToAngularCheckoutPage,
            goToRepayPage: goToRepayPage,
            goToGiftCardPage: goToGiftCardPage,
            getCompanyURL:getCompanyURL,
            goToNewsletterPage:goToNewsletterPage,
            goToWorldWidePage:goToWorldWidePage,
            goToStoreLocatorPage:goToStoreLocatorPage,
            goToShopCartPage: goToShopCartPage,
            goToLandingFeelPage: goToLandingFeelPage,
            goToMyAccountPage: goToMyAccountPage,
            goTo: goTo,
            links: {},
            getUrl: _getUrl,
            getPageUrl: _getPageUrl,
            setLinks:_setLinks,
            setNaverLink:_setNaverLink,
            isHomePage: isHomePage,
            isFeelPage: _isFeelPage,
            isCategoryPage: _isCategoryPage,
            isProductPage: _isProductPage
        };

        window.addEventListener('cms-change-language', function(event) {
            if (event.detail) {
                const language = event.detail.language;
                if (language) {
                    const langId = language.id;
                    inditex.iLangId = langId;
                    const lastStore = {
                        langId: inditex.iLangId,
                        storeId: inditex.iStoreId
                    };
                    inditex.setLocalStorage('LAST_STORE', JSON.stringify(lastStore));
                    if (isHomePage()) {
                        goToHomePage(null, _getStoreParams());
                    }
                    if (_isCategoryPage()) {
                        window.location.href = inditex.encodeUrl({
                            action: 'ItxCategoryPage',
                            params: {
                                storeId: inditex.iStoreId,
                                langId: inditex.iLangId,
                                catalogId: inditex.iCatalogId,
                                categoryId: inditex.iCategoryId
                            },
                            isMobile: false,
                            isAjax: false
                        });
                    } else {
                        goTo(inditex.iPage);
                    }
                }
            }
        });

        window.addEventListener('cms-goto-worldwide', function(event) {
            goTo('ItxWorldWidePage');
        });
        
        return service;

        /**
        * @ngdoc method
        * @name _setLinks
        * @private
        * @methodOf common.service:NavigationService
        * @description
        * Set the fixed links
        */
        function _setLinks(){
            this.links = {
                giftcard: this.getUrl('ItxGiftCardPage',null,null),
                help:  this.getUrl('ItxHelpPage',null,null),
                company: this.getUrl('ItxCompanyPage',null,null),
                storeLocator: this.getUrl('ItxStoreLocatorPage',null,null),
                newsletter: this.getUrl('ItxNewsletterPage',null,null),
                home: this.getUrl('ItxHomePage', false, false),
                homeMen: this.getPageUrl('ItxHomeMenPage', false, false),
                homeWomen: this.getPageUrl('ItxHomePage'),
                shopCart: this.getUrl('ItxShopCartPage', false, false),
                checkout: this.getUrl('ItxCheckoutPage', false, false),
            };
        }

        function _setNaverLink(){
            var naverlink = {
                naverLogin: this.getUrl('ItxNaverLoginPage', false, false)
            }
            return naverlink.naverLogin;
        }

        /**
        * @ngdoc method
        * @name goTo
        * @private
        * @methodOf common.service:NavigationService
        * @description
        * Get the URL and navigate to the generated URL.
        * 
        * @param {string} pageName Page name.
        * @param {string} urlParams URL optional params object
        */
        function goTo (pageName,urlParams,storeParams) {
            window.location.href = _getUrl(pageName,urlParams,storeParams);
        }
        /**
        * @ngdoc method
        * @name _getUrl
        * @methodOf common.service:NavigationService
        * @description
        * Get the url through `inditex.encodeUrl` function with the given page name.
        * If urlParams given, serialize object with `jQuery.param()` function and concatenate to the URL.
        * 
        * @param {string} pageName Page name.
        * @param {string} urlParams URL optional params object.
        * @returns {string} URL string
        * @example
        * <pre>
        *   var url = _getUrl('ItxCheckoutAuthPage', {
                    loginOnly: true, 
                    redirect: https%3A%2F%2Flocalhost%2Fpt%2Fsfi-returns.html%3FrmaId%3D11776003
                })

        * </pre>
        */
        function _getUrl (pageName,urlParams, storeParams){
            var url;

            if (!pageName) {
                throw new ReferenceError('Missing parameter: pageName');
            }

            if(pageName==='ItxWorldWidePage'){
                url = inditex.getWorldWideUrl(false);
            
                if (url.indexOf('.cn/') > -1) {
                    url = url.replace('.cn/', '.com/');
                }
                return url;
            }

            if(pageName==='ItxHomePage'){
                pageName = _getHomePageName();
            }

            url= inditex.encodeUrl({
                action : pageName,
                params : _getStoreParams(storeParams),
                isMobile : false,
                isAjax : false
            });

            if(urlParams){
                url = url + '?'+ jQuery.param(urlParams);
            }

            return url;
        }

        function _getPageUrl (pageName){
            var url;

            if (!pageName) {
                throw new ReferenceError('Missing parameter: pageName');
            }

            return inditex.encodeUrl({
                action : pageName,
                params : _getStoreParams(false),
                isMobile : false,
                isAjax : false
            });
        }

        /**
        * @ngdoc method
        * @name _getStoreParams
        * @methodOf common.service:NavigationService
        * @description
        * Get the store params object with the given param information or current store information if no params given.
        * @param {object} params Store Object
        * @returns {object} Store object filled.
        */
        function _getStoreParams(params){
            if(inditex.iPage === 'ItxWorldWidePage'){
                return {
                    storeId : (params && params.iStoreId) ||  inditex.iStoreId,
                    langId : (params && params.iLangId) ,
                    catalogId : (params && params.iCatalogId)
                };
            } else {
                return {
                    storeId : (params && params.iStoreId) ||  inditex.iStoreId,
                    langId : (params && params.iLangId) || inditex.iLangId,
                    catalogId : (params && params.iCatalogId) || inditex.iCatalogId
                };
            }
        }
        /**
         * @ngdoc method
         * @name goToAuthPage
         * @methodOf common.service:NavigationService
         * @description
         * Navigate to the Authentication Page.*/
        function goToAuthPage(params) {
            // Comprobamos si el nuevo login esta activo
            CmsConfigSvc.getProperty('enable_login_apolo')
                .then(function (newLoginEnable) {
                    if (newLoginEnable) {
                        var url = joyr.utils.getCommonPageUrl('ItxHomePage', false, false) + 'authentication';
                        window.location = url;
                    } else {
                        goTo('ItxCheckoutAuthPage', params);
                    }
                })
                .catch(function (error) {
                    goTo('ItxCheckoutAuthPage', params);
                });
        }
        /**
        * @ngdoc method
        * @name goToHelpPage
        * @methodOf co
        * mmon.service:NavigationService
        * @description
        * Get the company URL based in the section parameter. If no parameter given, then
        * returns the main URL. Otherwise returns the subsection.
        * @param {number} section Section number
        * @returns {string} URL string to help
        */
        function getHelpURL(section){
            var defaultURL =  this.links.help;
            return (!section)? defaultURL : defaultURL + '#/'+ section;
        }
        /**
        * @ngdoc method
        * @name goToCheckoutPage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the tunnel
        */
        function goToCheckoutPage(){
            goTo('ItxCheckoutPage');
        }
        /**
        * @ngdoc method
        * @name goToHomePage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the home.
        * @param {object} storeParams Store object
        * @param {object} section Section gender
        */
        function goToHomePage(section, storeParams){
            goTo(_getHomePageName(section), null, storeParams);
        }
        /**
        * @ngdoc method
        * @name goToGiftCardPage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to giftcard page
        */
        function goToGiftCardPage(){
            goTo('ItxGiftCardPage');
        }       
        
        /**
        * @ngdoc method
        * @name getCompanyURL
        * @methodOf common.service:NavigationService
        * @description
        * Get the company URL based in the section parameter. If no parameter given, then
        * returns the main URL. Otherwise returns the subsection.
        * @param {number} section Section number
        * @returns {string} URL string to company
        */
        function getCompanyURL(section){
            var defaultURL =  this.links.company;
            return (!section)? defaultURL : defaultURL + '#/company/'+ section;
        }

        /**
        * @ngdoc method
        * @name goToNewsletterPage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the Newsletter page
        */
        function goToNewsletterPage(){
            goTo('ItxNewsletterPage');
        }

        /**
        * @ngdoc method
        * @name goToWorldWidePage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the world wide page
        */
        function goToWorldWidePage(){
            goTo('ItxWorldWidePage');
        }

        /**
        * @ngdoc method
        * @name goToStoreLocatorPage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the store locator page
        */
        function goToStoreLocatorPage(){
            goTo('ItxStoreLocatorPage');
        }

        /**
        * @ngdoc method
        * @name goToShopCartPage
        * @methodOf common.service:NavigationService
        * @description
        * Navigate to the shop cart page.
        */
        function goToShopCartPage(params){
            goTo('ItxShopCartPage',params);
        }

        /**
         * @ngdoc method
         * @name goToLandingFeelPage
         * @methodOf common.service:NavigationService
         * @description
         * Navigate to the Massimo Dutti Feel landing page
         */
        function goToLandingFeelPage() {
            goTo('ItxMassimoDuttiFeelPage');
        }

        /**
         * Función para dirigir a My Account
         */
        function goToMyAccountPage(params) {
            const url = _getUrl('ItxMyAccountPage');

            window.location.href = url + '#/' + params;
        }

        function goToAngularCheckoutPage(order) {
            // workaround temporal, la llamada a inditex.encodeUrl con "ItxAngularCheckoutPage" falla
            // goTo('ItxAngularCheckoutPage');
            var url = inditex.encodeUrl({
                action: 'ItxHomePage',
                params: {
                    storeId : inditex.iStoreId,
                    langId : inditex.iLangId
                },
                isMobile: false,
                isAjax: false
            });
            
            window.location.href = url + 'checkout/';
        }

        function goToRepayPage(order) {
            if (!order || !order.repayable) {
                return;
            }

            var url = inditex.encodeUrl({
                action: 'ItxHomePage',
                params: _getStoreParams(),
                isMobile: false,
                isAjax: false
            });

            window.location.href = `${url}order-repayment?order=${order.id}` + '';
        }

        function _getHomePageName(section) {
            var pageName;
            if(!section){
                section = inditex.getLocalStorage('LAST_SECTION');
            } else {
                inditex.setLocalStorage('LAST_SECTION',section.toUpperCase());
            }
            if(section){
                switch (section.toLowerCase()) {
                    case 'men':
                        pageName = 'ItxHomeMenPage';
                        break;
                    case 'bg':
                        pageName = 'ItxHomeBgPage';
                        break;
                    default:
                        pageName = 'ItxHomePage';
                        break;
                }
            } else {
                pageName = 'ItxHomePage';
            }
            return pageName;
        }

        function isHomePage() {
            return inditex.iPage === 'ItxHomePage' || 
                inditex.iPage === 'ItxHomeMenPage' ||
                inditex.iPage === 'ItxHomeWomenPage' ||
                inditex.iPage === 'ItxHomeBgPage';
        }

        /**
         * Función para comprobar si la página actual es la landing de Massimo Dutti Feel
         */
        function _isFeelPage() {
            return inditex.iPage === 'ItxMassimoDuttiFeelPage';
        }

        function _isCategoryPage() {
            return inditex.iPage === 'ItxCategoryPage';
        }
        
        function _isProductPage() {
            return inditex.iPage === 'ItxProductPage';
        }
    }

})();